export default function getColorDepth(): number {
  return window.screen.colorDepth
}

export function getColorDepthBlank(): number {
  return 8
}
